import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const TradeUpIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest} fillColor="none" strokeColor="currentColor">
      <path d="M16 7h6v6" />
      <path d="m22 7-8.5 8.5-5-5L2 17" />

      {/* HUgeIcons version */}
      {/* <path d="M15 8H20V13" />
      <path d="M20 8L13 15L9 11L4 16" /> */}
    </SvgIcon>
  )
}
